<template>
  <div class="content">
    <div class="content_tow">
      <div class="tow_title">
        <div class="title_chu">
          <img src="../../assets/销售分类.png">
        </div>
        <div class="title_top">
          <div>销售分类</div>
        </div>
      </div>
      <div class="new_saleTypeBox">
        <el-table class="flTable" :data="tableData" style="width: 572px;margin-bottom: 10px; " row-key="id"
                  @row-click="rowClick"
                  :default-expand-all='isFold' :tree-props="{ children: 'prodetailslist', }"
                  @sort-change="changeTableSort"
                  :cell-style="classificationTableStyle"
                  :header-cell-style="{color: '#666666',fontSize:'12px',fontWeight: '400',padding:'10px 0 0 0',marginTop:'10px',backgroundColor:'#FBF6F1'}">
          <el-table-column prop="flName" label="分类" fixed="left" class="flName" width="65px">
            <template slot-scope="scope">
              <div style="width:80%;display: flex;justify-content: space-between;">
                <div style="display: flex;">
                  <div v-if="scope.row.num == 0" style="width: 1px;height: 23px;"></div>
                  <div :class="scope.row.flName == '合计' ? 'flName' : ''" style="min-width:30px">
                    {{ scope.row.flName }}
                    <!-- {{ scope.row }} -->
                  </div>
                </div>

                <div style="display: flex;align-items: center;margin-left: 2px;"
                     :class="scope.row.flName == '合计' ? 'disp' : ''" v-if="scope.row.num !== 0">
                  <img style="width: 16px;height: 16px;" v-if="scope.row.isFold"
                       src="../../assets/下拉.png">
                  <img style="width: 16px;height: 16px;" v-else src="../../assets/收起.png">
                </div>
              </div>


            </template>
          </el-table-column>
          <el-table-column prop="name" label="菜品" fixed="left" width="120px" >
            <template slot-scope="scope">
              <div :class="scope.row.flName == '合计' ? 'flName' : ''">
                {{ scope.row.name }}
                <!-- {{ scope.row }} -->
              </div>

            </template>
          </el-table-column>
          <el-table-column prop="num" label="销量" sortable="custom" width="104px">
            <template slot-scope="scope">
              <div :class="scope.row.flName == '合计' ? 'flName' : ''">
                {{ scope.row.num }}
                <!-- {{ scope.row }} -->
              </div>

            </template>
          </el-table-column>
          <el-table-column prop="numMoney" label="金额" sortable="custom" width="120px">
            <template slot-scope="scope">
              <div :class="scope.row.flName == '合计' ? 'flName' : ''">
                {{ scope.row.numMoney }}元
                <!-- {{ scope.row }} -->
              </div>

            </template>
          </el-table-column>
          <el-table-column prop="numbfb" label="销售占比" sortable="custom" width="100px">
            <template slot-scope="scope">
              <div :class="scope.row.flName == '合计' ? 'flName' : ''">
                {{ scope.row.numbfb }}
                <!-- {{ scope.row }} -->
              </div>

            </template>
          </el-table-column>
          <el-table-column prop="zhenNum" label="赠送" width="63px">
            <template slot-scope="scope">
              <div :class="scope.row.flName == '合计' ? 'flName' : ''">
                {{ scope.row.zhenNum }}
                <!-- {{ scope.row }} -->
              </div>

            </template>
          </el-table-column>

        </el-table>

      </div>
    </div>
    <div class="content_tow">
      <div class="tow_title">
        <div class="title_chu">
          <img src="../../assets/销售类型 (1).png">
        </div>
        <div class="title_top">
          <div>销售类型</div>
        </div>
      </div>
      <div class="new_saleTypeBox">
        <el-table :data="tableDataOne" style="width:610px;margin-bottom: 10px;"
                  @sort-change="changeTableSortOne"
                  :cell-style="typeTableStyle"
                  :header-cell-style="{color: '#666666',fontSize:'12px',fontWeight: '400',padding:'10px 0 0 0',marginTop:'10px',backgroundColor:'#FBF6F1',}">
          <el-table-column prop="flName" label="类型" fixed="left" width="60px">
            <template slot-scope="scope">
              <div :class="scope.row.flName == '合计' ? 'flName' : ''">
                {{ scope.row.flName }}
                <!-- {{ scope.row }} -->
              </div>

            </template>
          </el-table-column>
          <el-table-column prop="num" label="台数" sortable="custom" width="70px">
            <template slot-scope="scope">
              <div :class="scope.row.flName == '合计' ? 'flName' : ''">
                {{ scope.row.num }}
                <!-- {{ scope.row }} -->
              </div>

            </template>
          </el-table-column>
          <el-table-column prop="numMoney" label="营业额" sortable="custom" width="120px">
            <template slot-scope="scope">
              <div :class="scope.row.flName == '合计' ? 'flName' : ''">
                {{ scope.row.numMoney }}元
                <!-- {{ scope.row }} -->
              </div>

            </template>
          </el-table-column>
          <el-table-column prop="jinMoneyy" label="净额" sortable="custom" width="120px">
            <template slot-scope="scope">
              <div :class="scope.row.flName == '合计' ? 'flName' : ''">
                {{ scope.row.jinMoneyy }}元
                <!-- {{ scope.row }} -->
              </div>

            </template>
          </el-table-column>
          <el-table-column prop="you" label="优惠" sortable="custom" width="120px">
            <template slot-scope="scope">
              <div :class="scope.row.flName == '合计' ? 'flName' : ''">
                {{ scope.row.you }}元
                <!-- {{ scope.row }} -->
              </div>

            </template>
          </el-table-column>
          <el-table-column prop="numbfb" label="占比" sortable="custom" width="120px">
            <template slot-scope="scope">
              <div :class="scope.row.flName == '合计' ? 'flName' : ''">
                {{ scope.row.numbfb }}
                <!-- {{ scope.row }} -->
              </div>

            </template>
          </el-table-column>

        </el-table>
      </div>

    </div>
    <div class="content_tow">
      <div class="tow_title">
        <div class="title_chu">
          <img src="../../assets/img/实时数据.png">
        </div>
        <div class="title_top">
          <div>支付方式占比</div>
        </div>
      </div>
      <div class="tow_content" style="padding: 10px;">
        <div style="text-align: left;width: 100%;" class="turnover">营业净额 {{ settleamount }} 元</div>
        <div id="main">
        </div>
      </div>
    </div>
    <div class="content_tow">
      <div class="tow_title">
        <div class="title_chu">
          <img src="../../assets/img/销售数据.png">
        </div>
        <div class="title_top">
          <div>销售核心数据</div>
        </div>
      </div>
      <div class="tow_content" style="padding: 0px;">
        <div style="width: 100%;padding: 10px;display: flex;justify-content: center;padding-bottom: 0px;">
          <div style="border-right: 1px dashed #EEEEEE;height: 60px;padding: 10px;display: flex;flex-direction: column;
                    justify-content: space-around;align-items: center;width: 33%;">
            <div class="coreDataTitle">
              到店人数
            </div>
            <div class="coreDataPrice">
              {{ havemealqty }}人
            </div>
          </div>
          <div style="border-right: 1px dashed #EEEEEE;height: 60px;padding: 10px;display: flex;flex-direction: column;
                    justify-content: space-around;align-items: center;width: 33%;">
            <div class="coreDataTitle">
              客单量
            </div>
            <div class="coreDataPrice">
              {{ dintableqty }}
            </div>
          </div>
          <div style="height: 60px;padding: 10px;display: flex;flex-direction: column;
                    justify-content: space-around;align-items: center;width: 33%;">
            <div class="coreDataTitle">
              人均消费
            </div>
            <div class="coreDataPrice">
              {{ avgamount }}元
            </div>
          </div>
        </div>
        <div style="width: 100%;display: flex;justify-content: center;padding: 10px; padding-top: 0px;">
          <div style="border-right: 1px dashed #EEEEEE;height: 60px;padding: 10px;display: flex;flex-direction: column;
                    justify-content: space-around;align-items: center;width: 33%;border-top:1px dashed #EEEEEE ;">
            <div class="coreDataTitle">
              最高消费金额
            </div>
            <div class="coreDataPrice">
              {{ maxamount }}元
            </div>
          </div>
          <div
              style="border-right: 1px dashed #EEEEEE;height: 60px;display: flex;flex-direction: column;
                    justify-content: space-around;align-items: center;width: 33%;border-top:1px dashed #EEEEEE ;padding: 10px;">
            <div class="coreDataTitle">
              最低消费金额
            </div>
            <div class="coreDataPrice">
              {{ minamount }}元
            </div>
          </div>
          <div style="height: 60px;display: flex;flex-direction: column;padding: 10px;
                    justify-content: space-around;align-items: center;width: 33%;border-top:1px dashed #EEEEEE ;">
            <div class="coreDataTitle">
              已退款金额
            </div>
            <div class="coreDataPrice">
              {{ refundamount }}元
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="content_tow">
      <div class="tow_title">
        <div class="title_chu">
          <img src="../../assets/应收金额.png">
        </div>
        <div class="title_top">
          <div>退款分析</div>
        </div>
      </div>
      <div class="tow_content" style="padding: 10px;flex-direction: column;">
        <div class="contentOne"
             style="display: flex; justify-content: space-around;height: 58px;background-color: #F8F8F8;padding: 5px;border-radius: 5px;margin-bottom: 10px">
          <div
              style="width: 33%;display: flex;flex-direction: column;align-items: center;justify-content: space-around;">
            <div class="analysisTitle">
              退款数量
            </div>
            <div class="analysisNumber">
              {{ sumcount }}
            </div>
          </div>
          <div
              style="width: 33%;display: flex;flex-direction: column;align-items: center;justify-content: space-around;">
            <div class="analysisTitle">
              退款总金额
            </div>
            <div class="analysisNumber">
              {{ sumamount }}元
            </div>
          </div>
          <div
              style="width: 33%;display: flex;flex-direction: column;align-items: center;justify-content: space-around;">
            <div class="analysisTitle">
              总客单
            </div>
            <div class="analysisNumber">
              {{ sumqty }}
            </div>
          </div>
        </div>
        <!-- <div> -->
        <el-table :data="tableDataTwo1" style="width: 100%;   --el-table-border-color: none;"
                  :cell-style="refundTableStyle"
                  :header-cell-style="{color: '#666666',fontSize:'12px',fontWeight: '400',padding:'10px 0 0 0',marginTop:'10px',backgroundColor:'#FBF6F1'}">
          <el-table-column prop="flName" label="桌台" fixed="left" width="60px">
            <template slot-scope="scope">
              <span class="otherName">{{ scope.row.flName }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="菜名" fixed="left" min-width="120px">
            <template slot-scope="scope">
              <span class="dishName">{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="num" label="退菜数" sortable width="100px">
            <template slot-scope="scope">
              <span class="otherName">{{ scope.row.num }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="numMoney" label="退菜金额" sortable width="100px">
            <template slot-scope="scope">
              <span class="otherName">{{ scope.row.numMoney }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="message" label="退菜原因" width="100px">
            <template slot-scope="scope">
              
              <span class="otherName">{{ scope.row.message }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="退菜时间" width="120px">
            <template slot-scope="scope">
              <span class="otherName">{{ scope.row.date }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="id" label="订单号" sortable width="200px">
            <template slot-scope="scope">
              <span class="otherName">{{ scope.row.id }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="!zhangkai" @click="zhangkais" :class="lengthIFg ? 'no' : ''">
          <img style="width: 64px;height: 20px;" src="../../assets/Group 2943.png">
        </div>
        <div v-else @click="shoufang" :class="lengthIFg ? 'no' : ''">
          <img style="width: 64px;height: 20px;" src="../../assets/Group 2943 (1).png">
        </div>
        <!-- </div> -->
      </div>
    </div>
    <not  :width="widths" v-if="notifg"/>
    <loading style="z-index: 10000000;" v-if="loadingIFg"></loading>
  </div>
</template>
<script>
import * as echarts from 'echarts';
import {unZip} from '../../utils/ZIP/index.js';
import loading from '../../components/loading/index.vue'
import not from '@/components/not/index.vue';
import moment from "moment";
import "moment/locale/zh-cn";

export default {

  data() {
    return {
      notifg: false,
      widths:0,
      loadingIFg: true,
      zhangkai: false,
      lengthIFg: false,
      tableData: [
        {
          id: 1,
          flName: '炒菜',
          name: '--',
          num: 149,
          numMoney: 2543.00,
          numbfb: '41%',
          zhenNum: 1,
          tableData: [
            {
              id: 11,
              flName: '炒菜',
              name: '樟树港辣椒炒肉',
              num: 57,
              numMoney: 1089.00,
              numbfb: '41%',
              zhenNum: 1,
            },
            {
              id: 12,
              flName: '炒菜',
              name: '樟树港辣椒炒肉',
              num: 57,
              numMoney: 1089.00,
              numbfb: '41%',
              zhenNum: 1
            },
            {
              id: 13,
              flName: '炒菜',
              name: '樟树港辣椒炒肉',
              num: 57,
              numMoney: 1089.00,
              numbfb: '41%',
              zhenNum: 1
            },
            {
              id: 14,
              flName: '炒菜',
              name: '樟树港辣椒炒肉',
              num: 57,
              numMoney: 1089.00,
              numbfb: '41%',
              zhenNum: 1
            },
          ]
        },
        {
          id: 2,
          flName: '炒菜',
          name: '--',
          num: 150,
          numMoney: 2543.00,
          numbfb: '41%',
          zhenNum: 1,
          tableData: [
            {
              id: 15,
              flName: '炒菜',
              name: '樟树港辣椒炒肉',
              num: 57,
              numMoney: 1089.00,
              numbfb: '41%',
              zhenNum: 1
            },
            {
              id: 16,
              flName: '炒菜',
              name: '樟树港辣椒炒肉',
              num: 57,
              numMoney: 1089.00,
              numbfb: '41%',
              zhenNum: 1
            },
            {
              id: 17,
              flName: '炒菜',
              name: '樟树港辣椒炒肉',
              num: 57,
              numMoney: 1089.00,
              numbfb: '41%',
              zhenNum: 1
            },
            {
              id: 18,
              flName: '炒菜',
              name: '樟树港辣椒炒肉',
              num: 57,
              numMoney: 1089.00,
              numbfb: '41%',
              zhenNum: 1
            },
          ]
        },
        {
          id: 3,
          flName: '炒菜',
          name: '--',
          num: 160,
          numMoney: 2543.00,
          numbfb: '41%',
          zhenNum: 1,
          tableData: [
            {
              id: 19,
              flName: '炒菜',
              name: '樟树港辣椒炒肉',
              num: 57,
              numMoney: 1089.00,
              numbfb: '41%',
              zhenNum: 1
            },
            {
              id: 20,
              flName: '炒菜',
              name: '樟树港辣椒炒肉',
              num: 57,
              numMoney: 1089.00,
              numbfb: '41%',
              zhenNum: 1
            },
            {
              id: 21,
              flName: '炒菜',
              name: '樟树港辣椒炒肉',
              num: 57,
              numMoney: 1089.00,
              numbfb: '41%',
              zhenNum: 1
            },
            {
              id: 22,
              flName: '炒菜',
              name: '樟树港辣椒炒肉',
              num: 57,
              numMoney: 1089.00,
              numbfb: '41%',
              zhenNum: 1
            },
          ]
        },
        {
          id: 4,
          flName: '合计',
          name: ' ',
          num: 1456,
          numMoney: 2543.00,
          numbfb: '41%',
          zhenNum: 3
        },

      ],
      tableDataOne: [
        {
          flName: '堂食',
          num: 41,
          numMoney: 2752.00,
          jinMoneyy: 2700.00,
          you: 200,
          numbfb: '41%',
        },
        {
          flName: '堂食',
          num: 41,
          numMoney: 2752.00,
          jinMoneyy: 2700.00,
          you: 200,
          numbfb: '41%',
        },
        {
          flName: '堂食',
          num: 41,
          numMoney: 2752.00,
          jinMoneyy: 2700.00,
          you: 200,
          numbfb: '41%',
        },
        {
          flName: '合计',
          num: 41,
          numMoney: 2752.00,
          jinMoneyy: 2700.00,
          you: 200,
          numbfb: '41%',
        },
      ],
      tableDataTwo: [
        {
          flName: 'A01',
          name: '樟树港辣椒炒肉',
          num: 1,
          numMoney: 64.00,
          message: '上菜不及时',
          date: '18:12',
          id: 'TS20240312142700126',
        },
        {
          flName: 'A01',
          name: '樟树港辣椒炒肉',
          num: 1,
          numMoney: 64.00,
          message: '上菜不及时',
          date: '18:12',
          id: 'TS20240312142700126',
        },
        {
          flName: 'A01',
          name: '樟树港辣椒炒肉',
          num: 1,
          numMoney: 64.00,
          message: '上菜不及时',
          date: '18:12',
          id: 'TS20240312142700126',
        },
        {
          flName: 'A01',
          name: '樟树港辣椒炒肉',
          num: 1,
          numMoney: 64.00,
          message: '上菜不及时',
          date: '18:12',
          id: 'TS20240312142700126',
        },
        {
          flName: 'A01',
          name: '樟树港辣椒炒肉',
          num: 1,
          numMoney: 64.00,
          message: '上菜不及时',
          date: '18:12',
          id: 'TS20240312142700126',
        },
        {
          flName: 'A01',
          name: '樟树港辣椒炒肉',
          num: 1,
          numMoney: 64.00,
          message: '上菜不及时',
          date: '18:12',
          id: 'TS20240312142700126',
        },
        {
          flName: 'A01',
          name: '樟树港辣椒炒肉',
          num: 1,
          numMoney: 64.00,
          message: '上菜不及时',
          date: '18:12',
          id: 'TS20240312142700126',
        },
      ],
      tableDataTwo1: [],
      isFold: false,
      dateArr: [],
      StoresId: 0,
      SalesAmountRatioList: [],
      settleamount: 0,
      EchartsData: [],
      SalesCoreList: [],
      havemealqty: 0,
      dintableqty: 0,
      avgamount: 0,
      maxamount: 0,
      minamount: 0,
      refundamount: 0,
      sumamount: 0,
      sumqty: 0,
      sumcount: 0,
      seltype: 0,
    }
  },
  methods: {

    // (退款)改变某一列单元格背景颜色
    refundTableStyle({row, column, rowIndex, columnIndex}) {
      // console.log(row); // 基本都在这里面  其余的可自行打印
      // 这里写逻辑判断(看你是什么需求)
      // columnIndex === 2表示第二列  prodetailslist
      if (rowIndex % 2 == 0 && columnIndex == 0 || rowIndex % 2 === 0 && columnIndex == 1) {
        // row.row.xxx代表你想改变单元格颜色的那个渲染值 可以根据状态给不同的颜色 比如 非常紧急 就给红色背景
        return 'background:#FFFCF8;'
      } else if (rowIndex % 2 === 1 && columnIndex == 0 || rowIndex % 2 === 1 && columnIndex == 1) {
        return 'background:#F7EFE7;'
      }
      if (rowIndex % 2 == 0 && columnIndex != 0) {

      } else if (rowIndex % 2 === 1 && columnIndex != 0 || rowIndex % 2 === 1 && columnIndex != 1) {
        return 'background:#F9F5F1;'
      }
    },


    // (销售分类)改变某一列单元格背景颜色
    classificationTableStyle({row, column, rowIndex, columnIndex}) {
      if (row.styleFlag) {
        if (columnIndex == 0 || columnIndex == 1) {
          return 'background:#FFFCF8;'
        } else {
          //   空白色
        }
      } else {
        if (columnIndex == 0 || columnIndex == 1) {
          return 'background:#F7EFE7;'
        } else {
          return 'background:#F9F5F1'
        }
      }
    },

    // (销售类型)改变某一列单元格背景颜色
    typeTableStyle({row, column, rowIndex, columnIndex}) {
      // console.log(row); // 基本都在这里面  其余的可自行打印
      // 这里写逻辑判断(看你是什么需求)
      // columnIndex === 2表示第二列
      if (rowIndex % 2 == 0 && columnIndex == 0) {
        // row.row.xxx代表你想改变单元格颜色的那个渲染值 可以根据状态给不同的颜色 比如 非常紧急 就给红色背景
        return 'background:#FFFCF8;'
      } else if (rowIndex % 2 === 1 && columnIndex == 0) {
        return 'background:#F7EFE7;'
      }
      if (rowIndex % 2 == 0 && columnIndex != 0) {

      } else if (rowIndex % 2 === 1 && columnIndex != 0) {
        return 'background:#F9F5F1;'
      }
    },

    rowClick(row, column, e) {
      if (column.label == '分类') {
        if (e.currentTarget.querySelector(".el-table__expand-icon")) {
          row.isFold = !row.isFold
          // this.isFold =
          e.currentTarget.querySelector(".el-table__expand-icon").click();
        }
      }
    },
    zhangkais() {
      this.tableDataTwo1 = this.tableDataTwo
      this.zhangkai = true
    },
    changeTableSort(column) {
      const orderGroup = []
      const fieldName = column.prop
      const sortingType = column.order
      this.tableData.map(item => {
        orderGroup.push(item)
      })
      // 降序排序
      if (sortingType == 'descending') {
        this.tableData = orderGroup.sort((a, b) => {
          let aVal = a[fieldName]
          let bVal = b[fieldName]
          console.log(a);
          // 令中心总体所在行指标值最大
          if (a.flName === "合计") {

            aVal = -2
          }
          if (b.flName === '合计') {
            bVal = -2
          }
          console.log(aVal);
          return bVal - aVal
        })
        console.log(this.tableData);
      } else if (sortingType == 'ascending') {
        // 升序排序
        this.tableData = orderGroup.sort((a, b) => {
          let aVal = a[fieldName]
          let bVal = b[fieldName]
          if (a.userName === '合计') {
            aVal = 99999999
          }
          if (b.userName === '合计') {
            bVal = 99999999
          }
          return aVal - bVal
        })
      } else {
        this.$refs.experienceInfoTable.clearSort() // 清除排序
      }
    },
    changeTableSortOne(column) {
      const orderGroup = []
      const fieldName = column.prop
      const sortingType = column.order
      this.tableDataOne.map(item => {
        orderGroup.push(item)
      })
      // 降序排序
      if (sortingType == 'descending') {
        this.tableDataOne = orderGroup.sort((a, b) => {
          let aVal = a[fieldName]
          let bVal = b[fieldName]
          console.log(a);
          // 令中心总体所在行指标值最大
          if (a.flName === "合计") {

            aVal = -2
          }
          if (b.flName === '合计') {
            bVal = -2
          }
          console.log(aVal);
          return bVal - aVal
        })
        console.log(this.tableDataOne);
      } else if (sortingType == 'ascending') {
        // 升序排序
        this.tableDataOne = orderGroup.sort((a, b) => {
          let aVal = a[fieldName]
          let bVal = b[fieldName]
          if (a.userName === '合计') {
            aVal = 99999999
          }
          if (b.userName === '合计') {
            bVal = 99999999
          }
          return aVal - bVal
        })
      }
    },
    shoufang() {
      this.tableDataTwo1 = this.tableDataTwo.slice(0, 5)
      this.zhangkai = false
    },
    getEcher() {
      var chartDom = document.getElementById('main');
      var myChart = echarts.init(chartDom);
      var option;
      let getWidth = document.body.offsetWidth - 20;
      console.log(getWidth);
      if (getWidth >= 500) {
        getWidth = 500
      }
      myChart.resize({
        width: getWidth,
        height: 300
      })

      option = {

        tooltip: {
          trigger: 'item'
        },
        series: [
          {
            type: 'pie',
            radius: '45%',
            data: this.EchartsData,
            label: {
              normal: {
                show: true,
                position: 'inner', // 数值显示在内部
                formatter: '{d}%', // 格式化数值百分比输出
                color: 'white'

              },
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          },
          {
            type: 'pie',
            radius: '45%',
            data: this.EchartsData,

            label: {
              alignTo: 'edge',
              formatter: function (e) {
                console.log(e);
                if (e.data.name === '大众美团' || e.data.name === '抖音' || e.data.name === '微信') {
                  return `\n${e.data.name}(${e.data.value}元)\n${e.data.OneName}${e.data.OneValue}元\n${e.data.TowName}${e.data.TowValue}元`
                }
                return `${e.data.name}(${e.data.value}元)\n`
              },
              minMargin: 5,
              edgeDistance: 10,
              lineHeight: 20,
              rich: {
                time: {
                  fontSize: 12,
                  color: '#12ab32'
                }
              },
              overflow: 'none',
            },
            labelLayout: function (params) {
              console.log(params);
              ;
              const isLeft = params.labelRect.x < myChart.getWidth() / 2;
              const points = params.labelLinePoints;
              // Update the end point.
              points[2][0] = isLeft
                  ? params.labelRect.x
                  : params.labelRect.x + params.labelRect.width;
              return {
                labelLinePoints: points
              };
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      };

      option && myChart.setOption(option);
    },
    async getTableOne() {
      if (this.$route.query.DateArr == null || this.$route.query.DateArr == undefined) {
        return
      }
      let PostData = {
        beginDate: this.dateArr[0],
        endDate: this.dateArr[1],
        storeid: this.StoresId,
      }
      let {ReturnTag} = await this.$server.post(`/WeCom/GetProductSalesTypeReportData`, PostData)
      let datas = unZip(ReturnTag)
      console.log(JSON.parse(datas));
      let dataOne = JSON.parse(datas)
      this.tableData = []
      // //                id: 1,
      // flName: '炒菜',
      //         name: '--',
      //         num: 149,
      //         numMoney: 2543.00,
      //         numbfb: '41%',
      //         zhenNum: 1,
      dataOne.resultList.forEach((item, index) => {
        console.log(item);
        item.id = item.protypeid
        item.flName = item.protypename
        item.name = '--'
        item.num = item.protypeqty
        item.numMoney = item.protypeamount
        item.numbfb = item.typesalseratio
        item.zhenNum = item.typegiveqty
        item.isFold = true
        item.prodetailslist.forEach((e, indexs) => {
          e.id = e.productcode + indexs
          console.log(e.id);
          e.flName = item.protypename
          e.name = e.productname
          e.num = e.productqty
          e.numMoney = e.productamount
          e.numbfb = e.salseratio
          e.zhenNum = e.giveqty
          e.isFold = true
        })
      })

      let HeData = {
        flName: '合计',
        name: '',
        num: dataOne.sumqty,
        numMoney: dataOne.sumamount,
        numbfb: '100%',
        zhenNum: dataOne.sumgiveqty,
      }

      this.tableData = dataOne.resultList
      this.tableData.push(HeData)

      // 做样式单双标记
      this.tableData.map((item, index) => {
        // 判断父元素单双
        if (index % 2 === 0) {
          item.styleFlag = false  // 深颜色
        } else if (index % 2 === 1) {
          item.styleFlag = true // 浅颜色
        }

        //   判断子元素单双
        if (item.prodetailslist) { // 有子元素
          item.prodetailslist.map((items, indexs) => {
            if (item.styleFlag) { // 当父元素为浅颜色 子元素第一个要从深颜色开始
              if (indexs % 2 === 0) {
                items.styleFlag = false
              } else if (indexs % 2 === 1) {
                items.styleFlag = true
              }
            } else {
              if (indexs % 2 === 0) {
                items.styleFlag = true
              } else if (indexs % 2 === 1) {
                items.styleFlag = false
              }
            }
          })
        }
      })
      console.log(this.tableData);
    },
    async getTableTow() {
      let PostData = {
        beginDate: this.dateArr[0],
        endDate: this.dateArr[1],
        storeid: this.StoresId,
      }
      let {ReturnTag} = await this.$server.post(`/WeCom/GetProductSalesOrderTypeReportData`, PostData)
      let datas = unZip(ReturnTag)
      console.log(JSON.parse(datas));
      let dataOne = JSON.parse(datas)
      // {
      //         flName: '堂食',
      //         num: 41,
      //         numMoney: 2752.00,
      //         jinMoneyy: 2700.00,
      //         you: 200,
      //         numbfb: '41%',
      //     },
      this.tableDataOne = []
      let dataOnes = {
        flName: '合计',
        num: 0,
        numMoney: 0,
        jinMoneyy: 0,
        you: 0,
        numbfb: '100%',

      }
      dataOne.SalesOrderTypeList.forEach(e => {
        e.flName = e.ordertypename
        dataOnes.num += e.dintableqty
        e.num = e.dintableqty
        dataOnes.numMoney += e.turnoveramount
        e.numMoney = e.turnoveramount
        dataOnes.jinMoneyy += e.settleamount
        e.jinMoneyy = e.settleamount
        dataOnes.you += e.discountamount
        e.you = e.discountamount
        e.numbfb = e.amountratio
      })
      this.tableDataOne = dataOne.SalesOrderTypeList
      this.tableDataOne.push(dataOnes)
      this.SalesAmountRatioList = dataOne.SalesAmountRatioList
      this.settleamount = this.SalesAmountRatioList[0].settleamount
      let EchartsData = [
        {
          name: "微信",
          value: this.SalesAmountRatioList[0].wxamount,
          OneName: '微信线上',
          OneValue: this.SalesAmountRatioList[0].onlinewxamount
          ,
          TowName: '微信扫码',
          TowValue: this.SalesAmountRatioList[0].scanwxamount
        },
        {name: "支付宝", value: this.SalesAmountRatioList[0].alipayamount},
        {name: "现金", value: this.SalesAmountRatioList[0].cashamount},
        {name: "挂账", value: this.SalesAmountRatioList[0].creditamount},
        {
          name: "大众美团",
          value: this.SalesAmountRatioList[0].Mamount,
          OneName: "套餐",
          OneValue: this.SalesAmountRatioList[0].MSettlesetmealamount,
          TowName: "代金券",
          TowValue: this.SalesAmountRatioList[0].Mvoucheramount
        },
        {
          name: "抖音",
          value: this.SalesAmountRatioList[0].Damount,
          OneName: "套餐",
          OneValue: this.SalesAmountRatioList[0].DSettlesetmealamount,
          TowName: "代金券",
          TowValue: this.SalesAmountRatioList[0].Dvoucheramount
        },
      ]
      this.EchartsData = EchartsData
      this.SalesCoreList = dataOne.SalesCoreList
      this.havemealqty = dataOne.SalesCoreList[0].havemealqty
      this.dintableqty = dataOne.SalesCoreList[0].dintableqty
      this.avgamount = dataOne.SalesCoreList[0].avgamount
      this.maxamount = dataOne.SalesCoreList[0].maxamount
      this.minamount = dataOne.SalesCoreList[0].minamount
      this.refundamount = dataOne.SalesCoreList[0].refundamount

      console.log(this.SalesCoreList);
      await this.getEcher()
      // console.log();
    },
    async getTableThree() {
      let PostData = {
        beginDate: this.dateArr[0],
        endDate: this.dateArr[1],
        storeid: this.StoresId,
      }
      let {ReturnTag} = await this.$server.post(`/WeCom/GetProductSalesRefundReportData`, PostData)
      let datas = unZip(ReturnTag)
      let dataOne = JSON.parse(datas)
      this.sumamount = dataOne.sumamount
      this.sumqty = dataOne.sumqty
      this.sumcount = dataOne.sumcount
      // {
      //         flName: 'A01',
      //         name: '樟树港辣椒炒肉',
      //         num: 1,
      //         numMoney: 64.00,
      //         message: '上菜不及时',
      //         date: '18:12',
      //         id: 'TS20240312142700126',
      //     },
      dataOne.ProductInforList.forEach(item => {
        item.flName = item.dintablename
        item.name = item.productname
        item.num = item.productqty
        item.numMoney = item.productamount
        item.message = item.refundreason == null ? '' : item.refundreason
        if (this.seltype == 0) {
          item.date = moment(item.refundtime).format('HH:mm')
        } else {
          item.date = moment(item.refundtime).format('MM-DD HH:mm')
        }

        item.id = item.ordercode
      })
      this.tableDataTwo = dataOne.ProductInforList
      if (this.tableDataTwo.length < 5) {
        this.lengthIFg = true
      }
      let length = this.tableDataTwo.length < 5 ? this.tableDataTwo.length : 5
      this.tableDataTwo1 = this.tableDataTwo.slice(0, length)
    }
  }
  ,
  async mounted() {
    this.loadingIFg = true
    this.zhangkai = false
    this.dateArr = this.$route.query.DateArr
    this.StoresId = this.$route.query.StoresId
    this.seltype = this.$route.query.seltype
    await this.getTableOne()
    await this.getTableTow()
    await this.getTableThree()
    setTimeout(() => {
      this.loadingIFg = false
    }, 1000)
  }
  ,
  components: {
    not,
    loading
  }
}
</script>
<style lang="scss" scoped>
@import '../../assets/hotcss/hotcss-master/src/px2rem.scss';

.new_saleTypeBox{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px 10px 0px 10px;
}

/deep/ .el-table{
  flex: none;
}

.contentOne {
  width: calc(100% - 20px);
}

.no {
  display: none;
}

.fxid {
  border: px2rem(0.5) solid #DDDDDD;
}

.content {
  width: calc(100% - 20px);
  background-color: #f5f5f5;
  padding: 10px;
}

.opne .van-popup {
  width: 90%;
}

.content_tow {
  border-radius: px2rem(25);
  margin-top: px2rem(20);
  background-color: #ffffff;

  .fengjiexiao {
    width: 100%;
    border: px2rem(1) dashed #DDDDDD;
  }

  .tow_title {
    display: flex;
    align-items: center;
    flex-direction: row;
    padding: 0 14px;
    height: 48px;
    background: linear-gradient(86.53deg, rgb(249, 230, 202) 0.884%, rgba(255, 251, 246, 0) 99.944%);
    border-top-right-radius: px2rem(25);
    border-top-left-radius: px2rem(25);

    .title_chu {
      width: 16px;
      height: 16px;
      margin-right: px2rem(10);

      img {
        width: 100%;
        height: 100%;
      }
    }

    .title_top {
      display: flex;
      flex: 1;
      justify-content: space-between;


      div {
        color: rgb(51, 51, 51);
        font-family: Alibaba;
        font-size: 16px;
        font-weight: 500;
        line-height: 16px;
        letter-spacing: 0px;
        text-align: left;

        /* 100% */

      }

      .top_red {
        color: #E30F0F;
        font-family: Alibaba PuHuiTi;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        /* 100% */
      }
    }

    div {
      color: #333;
      font-family: Alibaba PuHuiTi;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      /* 100% */
    }
  }

  .three_table_content:first-child {
    margin-top: 0px;
  }

  .tow_content {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding: 10px 10px 0px 10px;
    position: relative;

    .tow_content_one {
      width: 100%;
      padding-bottom: 10px;

      .tow_one {
        font-size: 14px;
        padding-bottom: 15px;

        .tow_one_top {
          color: #333;

          font-family: Alibaba;
          font-size: 16px;
          font-style: normal;
          font-weight: 500;
        }

        .tow_one_bouutom {
          margin-top: 12px;
          display: flex;

          .bouutom_one {
            color: #E30F0F;
            display: flex;
            align-items: center;
            font-family: Alibaba;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;

            img {
              width: 12px;
              height: 12px;
            }
          }

          .bouutom_tow {
            color: #999;
            font-family: Alibaba;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            margin-left: 10px;
          }
        }

      }

      .tow_tow {

        border-radius: 5px;
        font-size: 12px;
      }

      .tow_three {

        margin-top: 8px;

        .tow_three_title {
          color: #333;

          font-family: Alibaba;
          font-size: 14px;
          font-style: normal;
          font-weight: 500;
        }

        .tow_three_table {
          display: flex;
          flex-direction: column;
        }

        .three_maring {
          margin-top: 0px !important;
        }

        .three_table_content {
          margin-top: 8px;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .red {
            color: #E30F0F !important;
          }

          .three_table_content_name {
            color: #666;
            font-family: Alibaba;
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
          }


          .three_table_content_price {
            display: flex;
            color: #333;
            text-align: right;
            font-family: Alibaba;
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            display: flex;
            justify-content: center;
            align-items: center;

            .three_table_content_ifg {
              display: flex;
              justify-content: center;
              align-items: center;
            }

            img {
              width: 12px;
              height: 12px;
            }
          }
        }
      }
    }

  }
}

/deep/ .el-table__empty-text {
  line-height: 60px;
  width: 50%;
  color: #909399;
  z-index: -1;
}

.dishName {
  color: rgb(102, 102, 102);
  font-family: 思源黑体 CN;
  font-size: 14px;
  font-weight: 400;
  line-height: 14px;
  letter-spacing: 0px;
  text-align: left;
}

.otherName {
  color: rgb(51, 51, 51);
  font-size: 14px;
  font-weight: 400;
  line-height: 14px;
  letter-spacing: 0px;
  text-align: left;
}

</style>
<style>
.el-table {
  border: 0 !important;
}

.disp {
  display: none !important;
}

thead .cell {
  font-size: 12px;
  color: #666666;
}

tbody .el-table__cell {
  border: none !important;
}

.cell {
  text-align: left;
  width: 100%;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #333333;
}

.el-table .ascending .sort-caret.ascending {
  border-bottom-color: #C2986E !important;
}

.el-table .descending .sort-caret.descending {
  border-top-color: #C2986E !important;
}

/* .el-table__row--level-1 .cell .flName{
    width: 100%;
    flex: 1;
    display: flex;
    align-items:center;
} */
.el-table__row--level-1 .cell {
  display: flex;
  flex-direction: column;
  align-items: baseline;
  margin-left: 2px;
  color: rgb(123, 86, 50);
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0px;
}

.el-table__indent {
  display: none;
}

.el-table__row--level-1 img {
  display: none;
}

tbody {
  font-size: 14px;
}

.el-icon-arrow-right {
  display: none !important;
}

.el-table__fixed::before {
  background-color: white !important;
}

.el-table::before {
  background-color: white !important;
}

/* .el-table__expand-icon {
    background-image: url(../../assets/下拉.png);
    background-size: 100% 100%;
}

.el-table__expand-icon--expanded {
    background-image: url(../../assets/收起.png);
    background-size: 100% 100%;
    transform: none !important;
} */
.el-table__row--level-1 .el-table__expand-icon {
  display: none !important;
}

thead .el-table__expand-icon {
  padding-left: 1px;
}

.el-table__expand-icon {
  width: 1px !important;
  margin: 0px !important;
}

.flName {
  color: rgb(194, 152, 110);
  font-size: 14px;
  font-weight: 500;
  line-height: 14px;
  letter-spacing: 0px;
  text-align: left;
  /* margin-left: 2px; */
}

.turnover {
  color: rgb(51, 51, 51);
  font-size: 16px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0px;
  text-align: left;
}

.coreDataTitle {
  color: rgb(102, 102, 102);
  font-size: 14px;
  font-weight: 400;
  line-height: 14px;
  letter-spacing: 0px;
  text-align: center;
}

.coreDataPrice {
  color: rgb(51, 51, 51);
  font-size: 18px;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0px;
  text-align: center;
}

.analysisTitle {
  color: rgb(102, 102, 102);
  font-size: 14px;
  font-weight: 500;
  line-height: 14px;
  letter-spacing: 0px;
  text-align: center;
}

.analysisNumber {
  color: rgb(51, 51, 51);
  font-size: 16px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0px;
  text-align: center;
}


</style>